<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template>
  <b-form-checkbox
    v-model="checkedValue"
    class="config-checkbox"
    :name="`checkbox-${controller.KeyValue}`"
    :switch="switchprop"
    :disabled="disabled"
    @mouseover.native="onHover"
    @mouseleave.native="onLeave"
    @click.native="select($event)"
  >
    {{ controller.textName }}
  </b-form-checkbox>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CheckBoxConfiguration',
  props: {
    controller:{
      type:Object,
      required: true
    },
    switchprop:{
      type: Boolean,
      default:false
    },
    disabled:{
      type: Boolean,
      default:false
    }
  },
  computed: {
    checkedValue: {
      set (value) {
        this.controller.setValue(value)
      },
      get () {
        return this.controller.value
      }
    }
  },
  methods: {
    ...mapActions(['setContextOnHover','setConfigReportModifiedReportViewer','setContextFixElement']),
    onHover() {
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(this.controller.contextHelp)
      }
    },
    onLeave(){
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(null)
      }
    },
    select(event){
      this.setConfigReportModifiedReportViewer()
      if(this.controller.contextHelp!==null && event.target.id!==''){
        this.setContextFixElement(this.controller.contextHelp)
      }
    }
  }
}
</script>

<style>

</style>
